import { BaseDto } from './base.dto';
import { BusinessEntityDto } from './businessEntity.dto';
import { CurrencyDto } from './currency.dto';
import { MerchantDto } from './merchant.dto';
import { PoSystemOrderItemDto } from './poSystemOrderItem.dto';
import { PoSystemStatusDto } from './poSystemStatus.dto';
import { SupplierDto } from './supplier.dto';
import { UserDto } from './user.dto';

export class PoSystemOrderDto extends BaseDto {
  name?: string;
  poNumber: string;
  supplierContact: string;
  supplierContactEmail: string;
  poDate: Date;
  poFulfilmentDate?: Date;
  poTotalVatAmount: number;
  poTotal: number;
  note?: string;
  replyToEmail: string;
  merchant: MerchantDto;
  generatedByUser: UserDto;
  merchantBusinessEntity?: BusinessEntityDto;
  currency: CurrencyDto;
  supplier: SupplierDto;
  poStatus: PoSystemStatusDto;
  poSystemOrderItems?: PoSystemOrderItemDto[];
  supplierDeliveryAmountMessage?: string;
  supplierDeliveryQuantityMessage?: string;
  documentUrl?: string;
}
